import ReactDOM from "react-dom";
import React from "react";
import { Routes } from './../Core/Constants'
import { CatalogueProvider } from './../Providers/CatalogueProvider';

export default class SearchBox extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			searchTerm: this.props.searchString,
			showSuggest: false
		};
	}

	handleKeyPress = (event) => {
		if (event.charCode === 13) {
			event.preventDefault();
			this.handleSumbmitSearch(event);
			return;
		}
	}

	handleChange = (event) => {
		if (event.target.value.length > 2) {
			CatalogueProvider.getSuggestions(event.target.value, (data) => {
				this.setState({
					data: data,
					showSuggest: true
				});
			});
		} else {
			this.setState({
				showSuggest: false,
				data: [],
				searchTerm: event.target.value
			});
		}
		this.setState({
			searchTerm: event.target.value
		});
	}

	handleSumbmitSearch = (event) => {
		event.preventDefault();
		if (this.state.searchTerm) {
			window.location.href = Routes.Search + '?q=' + this.state.searchTerm;
		}
	}

	renderSuggestion = () => {
		const T = window.Texts.search;
		const { showSuggest, data } = this.state;
		if (showSuggest) {
			{/* dropdown menu */ }
			return (
				<div className="dropdown-menu" style={{display:'block'}}>
					<div className="dropdown-menu-box">
						{(data.categories.length > 0) ?
							<div className="dropdown-menu__group">
								<div className="dropdown-menu__group--title"><p>{T? T.Categories:'Kategorie'}</p><hr /></div>
								{data.categories.map((item, i) => {
									return (
										<div className="dropdown-menu__group--item category" key={'kat' + item.id}>
											<div className="content" onClick={() => window.location = item.url}>
												<div className="thumb"><img src="/Content/view/images/icon-folder.svg" alt="folder" /></div>
												<div className="text"><p>{item.shortPathName}</p></div>
											</div>
											<div className="arrow"><img src="/Content/view/images/icon-arrow.svg" alt="arrow" /></div>
										</div>);
								})}
							</div> : null}

						{(data.products.length > 0) ?
							<div className="dropdown-menu__group">


								<div className="dropdown-menu__group--title"><p>{T?T.Products:'Zboží'}</p><hr /></div>
								{data.products.map((item, i) => {
									return (
										<div className="dropdown-menu__group--item" key={'product' + item.id}>
											<div className="content" onClick={() => window.location = item.url}>
												<div className="thumb"><img src={item.photo.url} /></div>
												<div className="text"><p><strong>{item.name}</strong></p><br />
													<p dangerouslySetInnerHTML={{ __html: item.displayAvailability}}></p>
												</div>
											</div>
											<div className="arrow"><img src="/Content/view/images/icon-arrow.svg" alt="arrow" /></div>
										</div>);
								})}
							</div> : null}
						</div>
					<div className="dropdown-menu__group--footer"><a onClick={(e) => this.handleSumbmitSearch(e)} className="btn">{T? T.NextProducts:'Další zboží'}</a></div>
				</div>
			);
		}
	}

	render = () => {
		const { handleChange, renderSuggestion } = this
		return (
			<React.Fragment>
				<div className="form-group">
					<input value={this.state.searchTerm} autoComplete="off" onFocus={this.handleChange} onKeyPress={(e) => this.handleKeyPress(e)} name="searchphrase" type="text" id="searchphrase" onInput={(e) => handleChange(e)} onBlur={() => setTimeout(() => this.setState({ showSuggest: false }), 200)} />
					<button type="submit" onClick={(e) => this.handleSumbmitSearch(e)}/>
				</div>
				{renderSuggestion()}
			</React.Fragment>
		);
	}
}

//inicializace
var element = document.getElementById("app-search-form");
if (element) {
	var searchString = element.getAttribute('data-search');
	ReactDOM.render(<SearchBox searchString={searchString} />, element);
}
